import { useCallback, useEffect, useState } from 'react';

export function useOpenPrintMenu() {
    const [url, setUrl] = useState<string>();

    useEffect(() => {
        if (url === undefined) return;
        const printFrame = document.createElement('iframe');
        printFrame.style.display = 'none';
        printFrame.src = url;

        printFrame.onload = () => {
            const content = printFrame?.contentWindow ?? null;
            if (content === null) return;
            content.print();
        };

        document.body.appendChild(printFrame);

        return () => {
            document.body.removeChild(printFrame);
            URL.revokeObjectURL(url);
        };
    }, [url]);

    return useCallback(
        (blob: Blob) => {
            const url = URL.createObjectURL(blob);

            setUrl(url);
        },
        [setUrl],
    );
}
